
$(function () {

  // Function to start the countdown
        function startCountdown(duration, display) {
            let timer = duration, minutes, seconds;
            const countdownInterval = setInterval(function () {
                minutes = parseInt(timer / 60, 10);
                seconds = parseInt(timer % 60, 10);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;

                if(display) {
                  display.textContent = minutes + ":" + seconds;
                }

                if (--timer < 0) {
                    // Timer has ended, you can perform any actions here when the countdown reaches 0.
                    clearInterval(countdownInterval);
                } else {
                    // Save the remaining time in a cookie every second
                    document.cookie = "countdown_time=" + timer + "; path=/;";
                }
            }, 1000);
        }

        // Function to get the countdown time from the cookie (if it exists)
        function getCookie(name) {
            const value = "; " + document.cookie;
            const parts = value.split("; " + name + "=");
            if (parts.length === 2) return parts.pop().split(";").shift();
        }

        // Set the countdown time (300 seconds = 5 minutes)
        let countdownTimeInSeconds = 300;

        // Check if there's a saved countdown time in the cookie
        const savedCountdownTime = getCookie("countdown_time");
        if (savedCountdownTime !== undefined) {
            countdownTimeInSeconds = parseInt(savedCountdownTime, 10);
        }

        // Start the countdown
        const display = document.getElementById("timer");
        const display2 = document.getElementById("timer2");
        startCountdown(countdownTimeInSeconds, display);
        startCountdown(countdownTimeInSeconds, display2);
  
  var $submitButton = $(".cart--checkout-button button[type=submit]");
  var $fakeSubmitButton = $(".cart--checkout-button button[type=button]");

  function setCheckoutButton(){
    // var isTermChecked = $("#CartPageAgree").is(":checked")
    // if(isTermChecked){
    //   $submitButton.show();
    //   $fakeSubmitButton.hide();
    //   $("#terms-checked-error").hide();
    // }else{
    //   $submitButton.hide();
    //   $fakeSubmitButton.show();
    // }
  }
  setCheckoutButton();

  $("#CartPageAgree").on('change', function(){
    setCheckoutButton();
  });

  $("body").on("click", ".cart--checkout-button button[type=button]", function (evt) {
    console.log("click")
    $("#terms-checked-error").show();
    // $(this).removeClass("btn--loading");
    return true;
  });

  var $iframeVideo = $('[data-item="rte-content"] iframe[src*="youtube.com/embed"], [data-item="rte-content"] iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    if (!$(this).parents('.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });

  if($('.product-page--root').length){
    var productId = $('.product-page--root').data('product-id')

    window.on(`theme:product:${productId}:variantChanged`, function({detail:{variant}}){
      var $form = $('form[action^="/cart/add"]');

      var btaForm = $form.data("bta.bookingForm");

      if (btaForm) {
        //console.log("__varian", variant);
        //console.log("__btaForm", btaForm);
        //console.log("__getStartDate", btaForm.getStartDate());

        btaForm.setSelectedVariantId(variant.id);
      }
    });
  }
  
  // if( document.getElementById("visitors-data") !== null ){
  //   document.getElementById("visitors-data").innerHTML = Math.floor(Math.random() * 20) + 1;
  // }

  // Random number between 50 to 100 on product page
  function getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // Generate a random number between 50 and 100
  var randomNumber = getRandomNumber(50, 100); 

  // Display the random number in the HTML element
  var randomNumberDisplay = document.getElementById('visitors-data');
  randomNumberDisplay.textContent += randomNumber;


  
  if( document.getElementById("left-stock") !== null ){
    document.getElementById("left-stock").innerHTML = Math.floor(Math.random() * 7) + 1;
  }

  function isWeekend(date) {
      const day = date.getDay();
      return day === 0 || day === 6; // Sunday is 0, Saturday is 6
    }

    function addDays(date, days) {
      const newDate = new Date(date);
      newDate.setDate(date.getDate() + days);
      return newDate;
    }

    function getDateAfter4DaysExcludingWeekends() {
      const today = new Date();
      let daysToAdd = 2;

      while (daysToAdd > 0) {
        today.setDate(today.getDate() + 1);
        if (!isWeekend(today)) {
          daysToAdd--;
        }
      }
      return today;
    }

    // Get the date after 4 days (excluding weekends)
    const resultDate = getDateAfter4DaysExcludingWeekends();

    // Format the resultDate to a readable string in the format "day, date"
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    const formattedDate = resultDate.toLocaleString('en-US', options);

    // Append the result to the paragraph tag
    const outputParagraph = document.getElementById("delivery-date-block");
    outputParagraph.textContent = `Express Shipping Get It By ${formattedDate}`;
  
  
  $(document).ready(function () {
    setTimeout(function () {
      setCheckoutButton();
    }, 1000);
  })

  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
     $('.featured-grid--body--container.featured-grid--slider_mobi').flickity({
      // options
      cellAlign: 'left',
      groupCells: true,
      wrapAround: true
    });
  }

 /* document.querySelector('.header--cart-toggle').addEventListener('click', function(evt) {
    evt.preventDefault();
  });*/


  
   var mobileSlider = function() {
    if ($(window).width() < 767) { 
       $('.featured-grid--body--container.featured-grid--slider_mobi').flickity({
        // options
        cellAlign: 'left',
        groupCells: true,
        wrapAround: true
      });
    }
  };

  mobileSlider();

  $(document).on('shopify:section:load', function(event) { 
    mobileSlider();
  });
  

});
